/** @format */

import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import Title from "./mini-components/Title";
import ScrollReveal from "scrollreveal";
emailjs.init("NRFTEw4mu1alw1xwD"); // Initialisation avec votre User ID

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validate = () => {
    let validationErrors = {};
    if (!formData.name) validationErrors.name = "Le nom est requis.";
    if (!formData.email) {
      validationErrors.email = "L'email est requis.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      validationErrors.email = "Adresse email invalide.";
    }
    if (!formData.message) validationErrors.message = "Le message est requis.";
    return validationErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      sendEmail();
    }
  };

  const sendEmail = () => {
    emailjs
      .send(
        "service_t3sv5qe", // Remplacez par votre ID de service
        "template_xy0e07f", // Remplacez par votre ID de modèle
        {
          from_name: formData.name,
          to_name: "Plan&Drive",
          message: formData.message,
          user_name: formData.name,
          user_email: formData.email,
          reply_to: formData.email,
        }
      )
      .then(
        (response) => {
          setSuccessMessage("Votre message a été envoyé avec succès !");
          setFormData({
            name: "",
            email: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          console.error("Erreur lors de l'envoi de l'e-mail :", error);
        }
      );
  };

  useEffect(() => {
    // Initialize ScrollReveal
    const sr = ScrollReveal({
      origin: "bottom",
      distance: "30px",
      duration: 500,
      delay: 100,
      easing: "ease-in-out",
    });

    // Reveal elements
    sr.reveal(".reveal", { interval: 200 });
  }, []);

  return (
    <div className="relative">
      <section
        id="contact"
        className="min-h-screen px-4 sm:px-8 lg:px-16 flex flex-col w-full pb-16 sm:pb-0"
      >
        <Title title="Contact" textplacement="right" />

        <div className="grid sm:grid-cols-2 items-start gap-16 p-4 mx-auto max-w-4xl bg-white font-[sans-serif]">
          <div className="reveal">
            <h1 className="text-gray-800 text-3xl font-extrabold">
              Une question ? <br /> Un projet ? <br />
              Contactez-nous !
            </h1>
            <p className="text-sm text-gray-500 mt-4">
              Nous sommes ouverts à toute proposition de collaboration ou de
              projet. N'hésitez pas à nous envoyer un message en utilisant le
              formulaire ou en nous contactant directement par e-mail.
            </p>

            <div className="mt-12">
              <h2 className="text-gray-800 text-base font-bold">Email</h2>
              <ul className="mt-4">
                <li className="flex items-start flex-col">
                  <a
                    href="mailto:info@terrettaz.ch"
                    className="text-green-800 hover:underline"
                  >
                    <strong>info@terrettaz.ch</strong>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="ml-auto space-y-4 reveal">
            <input
              type="text"
              name="name"
              placeholder="Nom"
              value={formData.name}
              onChange={handleChange}
              className="w-full rounded-md py-3 px-4 bg-gray-100 text-gray-800 text-sm outline-blue-500 focus:bg-transparent"
            />
            {errors.name && (
              <p className="text-red-500 text-xs">{errors.name}</p>
            )}

            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full rounded-md py-3 px-4 bg-gray-100 text-gray-800 text-sm outline-blue-500 focus:bg-transparent"
            />
            {errors.email && (
              <p className="text-red-500 text-xs">{errors.email}</p>
            )}

            <input
              type="text"
              name="subject"
              placeholder="Sujet"
              value={formData.subject}
              onChange={handleChange}
              className="w-full rounded-md py-3 px-4 bg-gray-100 text-gray-800 text-sm outline-blue-500 focus:bg-transparent"
            />

            <textarea
              name="message"
              placeholder="Message"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              className="w-full rounded-md px-4 bg-gray-100 text-gray-800 text-sm pt-3 outline-blue-500 focus:bg-transparent"
            ></textarea>
            {errors.message && (
              <p className="text-red-500 text-xs">{errors.message}</p>
            )}

            <button
              type="submit"
              className="text-white bg-green-800 hover:bg-green-900 tracking-wide rounded-md text-sm px-4 py-3 w-full mt-6"
            >
              Envoyer
            </button>
            {successMessage && (
              <p className="text-green-500 text-xs mt-2">{successMessage}</p>
            )}
          </form>
        </div>
      </section>
    </div>
  );
}
